(function ($) {
    const behavior = 'polyu_theme.quick-access';
    Drupal.behaviors[behavior] = {
        attach: (context, settings) => {
            once(behavior, 'header', context).forEach(
                function() {
                    polyu_handle_quick_access();
                    scrollBehavior();
                }
            );
        }
    };

    function polyu_handle_quick_access() {
        $(".trigger-quick-access").on('click', function (e) {
            e.preventDefault();
            $("body").addClass("fixed-region-active");
            $(".region--fixed, .polyu_quick_access").addClass("is-active");
        });
        $('.sliding_pane_close').on('click', function (e) {
            e.preventDefault();
            $(".region--fixed, .polyu_quick_access").removeClass("is-active");
            $("body").removeClass("fixed-region-active");
        });
    }

    function scrollBehavior(){
        if (!$('.jupas-calculator').length){
            document.querySelectorAll('a[href^="#"]').forEach(anchor => {
                anchor.addEventListener('click', function (e) {
                    e.preventDefault()
            
                    document.querySelector(this.getAttribute('href')).scrollIntoView({
                        behavior: 'smooth'
                    });
                });
            });
        }
    }
})(jQuery);
